import React, { useCallback } from 'react';
import { StyledCell, StyledHeaderCell, StyledRow } from "../PriceTables/RowStyles";
import { Box, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import TextFieldForm from "components/Common/TextFieldForm";
import SelectForm from "components/Common/SelectForm";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslations } from "@fenetech/translations";

interface IProps {
    isEditMode: boolean
}

const ESignatureReportsGrid: React.FC<IProps> = ({ isEditMode }: IProps) => {

    const { control } = useFormContext();
    const tm = useTranslations();
    
    const { fields } = useFieldArray({
        control: control,
        name: "reportSettings"
    });

    const validateOffsetValue = useCallback((value: string): string | boolean => {
        if (value) {
            if (isNaN(Number(value))) {
                return tm.Get("Value must be a number.");
            }
        }

        return true;
    }, [tm]);

    const anchorUnits = [
        {
            value: "inches",
            label: "Inches"
        },
        {
            value: "mms",
            label: "Millimeters"
        },
        {
            value: "cms",
            label: "Centimeters"
        },
        {
            value: "pixels",
            label: "Pixels"
        }
    ]

    return <Box sx={{ display: "grid", width: "100%" }}>
        <TableContainer sx={{ width: "100%" }}>
            <Table sx={{ minWidth: "100%", width: "max-content" }} size="small" padding="none">
                <TableHead>
                    <TableRow>
                        <StyledHeaderCell style={{ width: "35%" }}>{tm.Get("Report")}</StyledHeaderCell>
                        <StyledHeaderCell style={{ width: "25%" }}>{tm.Get("Anchor Tag")}</StyledHeaderCell>
                        <StyledHeaderCell style={{ width: "20%" }}>{tm.Get("Units")}</StyledHeaderCell>
                        <StyledHeaderCell style={{ width: "10%" }}>{tm.GetWithParams("Offset {0}", "X")}</StyledHeaderCell>
                        <StyledHeaderCell style={{ width: "10%" }}>{tm.GetWithParams("Offset {0}", "Y")}</StyledHeaderCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {fields.map((field, index) => {
                        return <StyledRow key={`${field}${index}`}>

                            <StyledCell>
                                <TextFieldForm
                                    fieldName={`reportSettings.${index}.reportName`}
                                    readOnly={true}
                                    variant="standard"
                                    id={`reportSettings.${index}.reportName`}
                                    fullWidth
                                    label=""
                                />
                            </StyledCell>
                            
                            <StyledCell>
                                <TextFieldForm
                                    fieldName={`reportSettings.${index}.anchorTag`}
                                    disabled={!isEditMode}
                                    readOnly={false}
                                    variant="standard"
                                    id={`reportSettings.${index}.anchorTag`}
                                    fullWidth
                                    label=""
                                />
                            </StyledCell>

                            <StyledCell>
                                <SelectForm
                                    fieldName={`reportSettings.${index}.units`}
                                    dataSource={anchorUnits}
                                    keyField="value"
                                    valueField="value"
                                    displayField="label"
                                    translateDisplayField={true}
                                    label=""
                                    disabled={!isEditMode}
                                    readOnly={false}
                                    variant="standard"
                                    sx={{mb: 1.6}}
                                />
                            </StyledCell>

                            <StyledCell>
                                <TextFieldForm
                                    fieldName={`reportSettings.${index}.xOffset`}
                                    disabled={!isEditMode}
                                    readOnly={false}
                                    variant="standard"
                                    id={`reportSettings.${index}.xOffset`}
                                    fullWidth
                                    label=""
                                    validateValue={validateOffsetValue}
                                />
                            </StyledCell>

                            <StyledCell>
                                <TextFieldForm
                                    fieldName={`reportSettings.${index}.yOffset`}
                                    disabled={!isEditMode}
                                    readOnly={false}
                                    variant="standard"
                                    id={`reportSettings.${index}.yOffset`}
                                    fullWidth
                                    label=""
                                    validateValue={validateOffsetValue}
                                />
                            </StyledCell>
                        </StyledRow>
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
}

export default ESignatureReportsGrid;